import connect from 'components/Shared/connect';
import { IMenuItem } from 'models/IMenuItem';
import { INotifyLink } from 'models/INotifyLink';
import { hasElements, rm, NO_ELEMENT } from 'utils';
import { NotifyButton, ButtonProps } from 'components/Button';
import { Section } from 'components/Section';
import { getCategories, getFilteredCategories } from 'views/ProductlistPage/selectors';
import styles from './categoryNavigation.scss';
import cn from 'classnames';
import { isMobile } from 'components/Shared/responsive';

interface MergedProps {
  categories: IMenuItem[];
  campaigns?: IMenuItem;
  title?: string;
  isDesktopLayout?: boolean;
}

export const Category = ({
  url,
  ticket,
  title,
  appearance
}: INotifyLink & { appearance: ButtonProps['appearance'] }) => (
  <li className={styles.category}>
    <NotifyButton
      className={cn({ [styles.dark]: appearance === 'tertiary' })}
      appearance={appearance}
      border="thin"
      invert
      href={url}
      ticket={ticket}
    >
      {title}
    </NotifyButton>
  </li>
);

const _CategoryNavigation = ({ categories, campaigns }: MergedProps) => {
  return (
    <>
      {hasElements(categories) && (
        <ul className={styles.categories}>
          {categories.map((c, i) => (
            <Category {...c} appearance="tertiary" key={c.ticket || i} />
          ))}
          {campaigns && <Category appearance="primary" {...campaigns} />}
        </ul>
      )}
    </>
  );
};

const isCampaignCategory = (c: IMenuItem) => c.id.toLowerCase().includes('campaigns');
interface StateProps {
  _categories: IMenuItem[];
}
export const CategoryNavigation = connect<MergedProps, Record<string, undefined>, StateProps>(
  ({ currentPage }) => ({
    _categories: getCategories(currentPage)
  }),
  undefined,
  ({ _categories, ...state }, dispatch, props) => ({
    ...state,
    ...dispatch,
    ...props,
    campaigns: _categories.find(isCampaignCategory),
    categories: _categories.filter((c: IMenuItem) => !isCampaignCategory(c))
  })
)(_CategoryNavigation);

interface FilteredCategoryMergedProps {
  categories: IMenuItem[];
  isMobile: boolean;
}

export const FilteredCategoryNavigation = connect<
  FilteredCategoryMergedProps,
  Record<string, undefined>,
  StateProps
>(
  ({ currentPage, currentBreakpoint }) => ({
    _categories: getFilteredCategories(currentPage),
    isMobile: isMobile({ currentBreakpoint })
  }),
  undefined,
  ({ _categories, ...state }, dispatch, props) => ({
    ...state,
    ...dispatch,
    ...props,
    categories: _categories.filter((c: IMenuItem) => !isCampaignCategory(c))
  })
)(({ categories }: FilteredCategoryMergedProps) => {
  return hasElements(categories) ? (
    <Section title={rm('productlist_popular_filters')}>
      <_CategoryNavigation categories={categories} />
    </Section>
  ) : (
    NO_ELEMENT
  );
});
